import { CmsApiVideoBlockData } from 'modules/cms/api/types/blocks/CmsApiVideoBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpVideoBlock } from './CmsAmpVideoBlock';
import { CmsVideoBlock } from './CmsVideoBlock';

export const CmsVideoBlockMapping: CmsBlockMapping<CmsApiVideoBlockData> = {
  invariant: [
    {
      prop: 'videoUrl',
      msg: 'URL required for video',
    },
    {
      prop: 'width',
      msg: 'width required for video',
    },
  ],
  width: CmsMappedBlockWidth.NARROW,
  Component: CmsVideoBlock,
  AmpComponent: CmsAmpVideoBlock,
};
